import cn from 'classnames'

export const getTriggerStyles = (theme: any): string =>
   cn(
      `flex-shrink-0 cursor-pointer p-[2px] rounded-[4px] ${theme.hoverBgColor}`
   )
